import { ActionTree } from "vuex";
import { IPagination, RootState } from "@/types";
import { IStatus, IStatusListRequest, StatusState } from "@/types/status";
import CustomRequest from "../customRequest";

const actions: ActionTree<StatusState, RootState> = {
  async get({ commit }, id: number) {
    await CustomRequest.get<IPagination<IStatus>>({
      uri: `/status/${id}`,
      commit,
      target: "single",
    });
  },

  async getList({ commit }, params: IStatusListRequest) {
    await CustomRequest.get<IPagination<IStatus>>({
      uri: "/status",
      params,
      commit,
      target: "pagination",
    });
  },
};

export default actions;
